export const CREATE_PLC_SAFETY_EVENT = 'CREATE_PLC_SAFETY_EVENT';
export const CREATE_PLC_SAFETY_EVENT_SUCCESSFUL = 'CREATE_PLC_SAFETY_EVENT_SUCCESSFUL';
export const CREATE_PLC_SAFETY_EVENT_FAILED = 'CREATE_PLC_SAFETY_EVENT_FAILED';
